export function chicagoCalendarYear(now: Date = new Date()): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    year: 'numeric',
  }).formatToParts(now);
  const year = Number(parts.find(p => p.type === 'year')?.value);
  return Number.isFinite(year) ? year : now.getFullYear();
}

export function formatPurchasingDocNumber(prefix: 'PR' | 'PO', year: number, n: number): string {
  return `${prefix}-${year}-${String(Math.max(1, Math.round(n))).padStart(4, '0')}`;
}

export function nextCounterValue(current: unknown): number {
  const n = Number(current);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.round(n);
}

/**
 * Compute the next PR / PO counter values for a single transaction write.
 * On year rollover both series reset to 1; allocating only POs must not rewind
 * `nextPr` (and vice versa) when the year is unchanged (CRM #73).
 */
export function nextPurchasingCounters(args: {
  storedYear: number;
  year: number;
  nextPr: unknown;
  nextPo: unknown;
  /** How many PR numbers to take (0 or 1 in practice). */
  prCount?: number;
  /** How many PO numbers to take in this transaction. */
  poCount?: number;
}): { year: number; nextPr: number; nextPo: number; prStart: number; poStart: number } {
  const prCount = Math.max(0, Math.round(args.prCount || 0));
  const poCount = Math.max(0, Math.round(args.poCount || 0));
  const reset = !Number.isFinite(args.storedYear) || args.storedYear !== args.year;
  const prStart = reset ? 1 : nextCounterValue(args.nextPr);
  const poStart = reset ? 1 : nextCounterValue(args.nextPo);
  return {
    year: args.year,
    prStart,
    poStart,
    nextPr: prCount ? prStart + prCount : prStart,
    nextPo: poCount ? poStart + poCount : poStart,
  };
}
